import Modal from "react-bootstrap/Modal";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { useState, useEffect } from "react";

const PreredemptionModal = ({
  showPreredemptionModal,
  setShowPreredemptionModal,
  voucherValidationData,
  redeemVoucher,
}) => {
  const [controlNumber, setControlNumber] = useState("");
  const [activeButton, setActiveButton] = useState(null);
  const [done, setDone] = useState(false);

  const handleClickNumber = (digit) => {
    if (controlNumber.length < 2) {
      setControlNumber((prevValue) => prevValue + digit);
    }
  };

  const handleClickBackspace = () => {
    setControlNumber((prevValue) => prevValue.slice(0, -1));
  };

  const handleTouchStart = (digit) => {
    setActiveButton(digit);
  };

  const handleTouchEnd = () => {
    setActiveButton(null);
  };

  useEffect(() => {
    setControlNumber("");
    setDone(false);
  }, [voucherValidationData]);

  useEffect(() => {
    if (controlNumber.length === 2) {
      if (done === false) {
        setDone((prevValue) => true);
        setTimeout(function () {
          setShowPreredemptionModal(false);
          redeemVoucher(voucherValidationData.id, controlNumber);
        }, 500);
      }
    }
  }, [
    controlNumber,
    redeemVoucher,
    setShowPreredemptionModal,
    voucherValidationData,
    done,
  ]);

  const buttonStyleNumber = {
    border: "none",
    borderRadius: "50%",
    fontSize: "24px",
    fontWeight: "bold",
    height: "80px",
    width: "80px",
    margin: "auto",
    color: "#3478f6",
  };

  const buttonStyleBackspace = {
    border: "none",
    borderRadius: "50%",
    fontSize: "24px",
    fontWeight: "bold",
    height: "80px",
    width: "80px",
    margin: "auto",
    color: "#6e757c",
    background: "none",
  };

  return (
    <Modal
      show={showPreredemptionModal}
      fullscreen="md-down"
      onHide={() => setShowPreredemptionModal(false)}
    >
      <Modal.Header>
        <Modal.Title>Gutschein einlösen</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          Den PIN zum Einlösen von "{voucherValidationData.title}" erhältst du
          bei{" "}
          <a
            className="link-offset-2"
            href={voucherValidationData.link}
            target="_blank"
            rel="noreferrer"
          >
            {voucherValidationData.location}
          </a>
          .
        </div>
        <div className="text-center mb-4">
          <h2>&nbsp;{controlNumber}&nbsp;</h2>
        </div>
        <Container
          className="text-center"
          style={{ maxWidth: "290px", margin: "0 auto", padding: "0" }}
        >
          <Row className="mb-2">
            {[1, 2, 3].map((digit) => (
              <Col key={digit}>
                <Button
                  style={{
                    ...buttonStyleNumber,
                    background: activeButton === digit ? "#99bbfa" : "#ebf1fe",
                  }}
                  onClick={() => handleClickNumber(digit)}
                  onTouchStart={() => handleTouchStart(digit)}
                  onTouchEnd={handleTouchEnd}
                >
                  {digit}
                </Button>
              </Col>
            ))}
          </Row>
          <Row className="mb-2">
            {[4, 5, 6].map((digit) => (
              <Col key={digit}>
                <Button
                  style={{
                    ...buttonStyleNumber,
                    background: activeButton === digit ? "#99bbfa" : "#ebf1fe",
                  }}
                  onClick={() => handleClickNumber(digit)}
                  onTouchStart={() => handleTouchStart(digit)}
                  onTouchEnd={handleTouchEnd}
                >
                  {digit}
                </Button>
              </Col>
            ))}
          </Row>
          <Row className="mb-2">
            {[7, 8, 9].map((digit) => (
              <Col key={digit}>
                <Button
                  style={{
                    ...buttonStyleNumber,
                    background: activeButton === digit ? "#99bbfa" : "#ebf1fe",
                  }}
                  onClick={() => handleClickNumber(digit)}
                  onTouchStart={() => handleTouchStart(digit)}
                  onTouchEnd={handleTouchEnd}
                >
                  {digit}
                </Button>
              </Col>
            ))}
          </Row>
          <Row className="mb-2">
            <Col></Col>
            <Col>
              <Button
                style={{
                  ...buttonStyleNumber,
                  background: activeButton === 0 ? "#99bbfa" : "#ebf1fe",
                }}
                onClick={() => handleClickNumber(0)}
                onTouchStart={() => handleTouchStart(0)}
                onTouchEnd={handleTouchEnd}
              >
                0
              </Button>
            </Col>
            <Col>
              {controlNumber.length > 0 && (
                <Button
                  style={buttonStyleBackspace}
                  onClick={() => handleClickBackspace()}
                >
                  ⌫
                </Button>
              )}
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => setShowPreredemptionModal(false)}
        >
          <div>Abbrechen</div>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PreredemptionModal;
